<template>
    <button class="btn btn-default" @click="sendActivate()" v-if="state">
      Activer
    </button>
    <button class="btn btn-default" @click="sendDeactivate()" v-else>
      Désactiver
    </button>
</template>

<script>
  export default {
    props: {
      state: Boolean,
    },
    methods: {
      sendActivate () {
        this.$emit('activate')
      },
      sendDeactivate () {
        this.$emit('deactivate')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// ActivateDeactivateButton.vue?72e7c7aa